import {WorkshopSceneState} from "../models/WorkshopSceneState";
import {Page} from "../models/Page";

export const convertWorkshopState2Page = (workshopState:WorkshopSceneState)=>{

    switch (workshopState){
        case WorkshopSceneState.Wait:
            return Page.Top;
        case WorkshopSceneState.Video:
            return Page.Video;
        case WorkshopSceneState.Drawing:
            return Page.AreaSelect;
        default:
            return Page.Top;
    }
};